import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/Auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.checkAuthenticated().pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          if (this.authService.needsCallback) {
            this.authService.needsCallback = false;
            return this.router.createUrlTree(['/callback']);
          }
          return true;
        } else {
          return this.router.createUrlTree(['/login']);
        }
      })
    );
  }
}
